var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 84,
    viewBox: "0 0 78 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7145 3.79794L53.1795 14.1926L32.6089 0L17.621 19.9936L0.682746 14.6848L10.2919 43.4468V44.2476C4.81919 44.4753 0.359863 48.9126 0.359863 54.3532C0.359863 59.9394 4.96254 64.468 10.6402 64.468L11.3834 64.4675C14.8153 75.7591 25.8985 84 38.9999 84C52.1012 84 63.1844 75.7591 66.6163 64.4675L67.6988 64.4626C73.2194 64.2864 77.6399 59.8277 77.6399 54.3532L77.6344 54.0193C77.4591 48.7036 73.1152 44.4247 67.7145 44.2443V3.79794ZM15.2933 43.8832L15.2487 57.0615C15.2487 69.0701 25.6062 78.8837 38.537 79.1129L38.9999 79.117C51.9908 79.117 62.5012 69.4447 62.7467 57.4894L62.7499 36.0696L15.2933 43.8832ZM72.6769 54.3532C72.6769 57.1254 70.4855 59.3941 67.714 59.5736V49.1329L68.2601 49.1962C70.7679 49.6171 72.6769 51.7658 72.6769 54.3532ZM10.0106 49.1577L10.2857 49.1329V59.5736C7.51428 59.3941 5.3228 57.1254 5.3228 54.3532C5.3228 51.6734 7.37062 49.4641 10.0106 49.1577Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1418 74.4576C35.8365 66.7936 45.0405 63.3309 51.586 67.8948C52.5544 68.57 52.7773 69.8818 52.084 70.8248C51.3907 71.7678 50.0436 71.9849 49.0753 71.3097C45.0539 68.5058 39.3992 70.6332 38.358 75.3417C38.1073 76.4755 36.9603 77.1967 35.796 76.9526C34.6317 76.7085 33.8911 75.5914 34.1418 74.4576Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.126 50.4621C27.1846 50.3402 28.3439 50.0798 29.5272 49.6761C31.5951 48.9704 33.325 47.9672 34.4148 46.9358C34.5948 47.4567 34.6957 48.0491 34.6957 48.7127L34.6957 51.3832C34.6957 57.5092 26.126 57.5686 26.126 51.3832V50.4621ZM42.1922 47.1916C42.0654 47.6478 41.9957 48.1548 41.9957 48.7127V51.3832C41.9957 57.5686 50.5654 57.5092 50.5654 51.3832V50.4994C49.4101 50.3993 48.118 50.1272 46.7958 49.6761C44.8993 49.0289 43.2872 48.1315 42.1922 47.1916Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo06);
export default __webpack_public_path__ + "static/media/logo_06.b9cb587d18a19d0f5cae9de65b255122.svg";
export { ForwardRef as ReactComponent };